import { convertRowsToData } from '../utils/dataUtils'
export default function ChoroplethDataController(rows, config, hiddenItems) {
  let propperHeaders = ['id', config.ItemsHelper.colorKey]
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 1)
  if (hiddenItems) data = data.filter(d => hiddenItems.indexOf(d[config.ItemsHelper.colorKey]) < 0)
  let features = config.features.map(feature => {
    let candidate = data.find(d => d.id === feature.properties[config.featureIdProperty])
    // if(candidate && hiddenItems &&hiddenItems.indexOf(candidate[config.ItemsHelper.colorKey])>=0) candidate = null
    let result = {
      id: feature.properties[config.featureIdProperty],
      label: feature.properties[config.featureLabelProperty],
      centroid: feature.properties.centroid,
    }
    if (candidate) result[config.ItemsHelper.colorKey] = candidate[config.ItemsHelper.colorKey]
    else result[config.ItemsHelper.colorKey] = null
    return result
  })
  return features
}
